import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { OrderBumpInterface } from 'common/types/entities/order-bump-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createOrderBump(
  parentId: string,
  title: string,
  masterBlockId?: MasterBlockIdType,
): OrderBumpInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.OrderBump, parentId, masterBlockId),
    fontSize: 24,
    lineHeight: 59,
    fontWeight: 'bold',
    childIds: [],
    title,
    color: 'rgba(68, 149, 49, 1)',
    headerBackgroundColor: 'rgba(254, 250, 169, 1)',
    backgroundColor: 'rgba(251, 248, 230, 1)',
    justifyContent: 'center',
    border: {
      style: BorderStyleEnum.dashed,
      width: 3,
      color: 'rgba(0, 0, 0, 1)',
    },
    margin: { marginTop: 0, marginRight: 0, marginBottom: 15, marginLeft: 0 },
    padding: {
      paddingTop: 8,
      paddingRight: 8,
      paddingBottom: 8,
      paddingLeft: 8,
    },
  }
}
